// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-void-expression (autogenerated)
// tslint:disable:no-string-literal (autogenerated)
import * as React from 'react';
import * as ReactDom from 'react-dom';
import { getMainDiv } from './prepare-dom';
import { getOnlyI18nData } from './get-settings-data';
import { Provider } from 'react-redux';
import store from '../../components/base/redux-store';
import bootstrapLog from './bootstrap-log';
import { AuthContainer } from '../../components/auth-container';

let rootInstance;
let mainDiv;

const render = Component => {
    rootInstance = ReactDom.render(
        <Provider store={store}>
            <Component />
        </Provider>,
        mainDiv
    );
};

// tslint:disable-next-line:typedef (autogenerated)
export async function getAuthInstance() {
    bootstrapLog('Root instance created in', 'Creating root instance...');
    try {
        if (rootInstance) {
            return rootInstance;
        }
        await getOnlyI18nData(['auth', 'user']);
        mainDiv = await getMainDiv();
        rootInstance = render(AuthContainer);
        bootstrapLog('Root instance created in', 'Root instance created.');
    } catch (error) {
        bootstrapLog(
            'Root instance created in',
            'Error creating root instance:' + error.toString()
        );
        throw error;
    }
    return rootInstance;
}
